import * as Sentry from "@sentry/react";

export interface InitSentryConfig {
  dsn: string;
  app: string;
  release: string;
  environment?: string;
  force?: boolean;
}

let initialized = false;

export function initSentry(config: InitSentryConfig): void {
  if (initialized) return;
  if (process.env.NODE_ENV !== "production" && !config.force) return;

  Sentry.init({
    dsn: config.dsn,
    environment: config.environment ?? process.env.NODE_ENV,
    release: config.release,
    tracesSampleRate: 0,
    replaysSessionSampleRate: 0,
    replaysOnErrorSampleRate: 1.0,
    integrations: [
      Sentry.replayIntegration({
        maskAllText: false,
        blockAllMedia: false,
      }),
    ],
  });
  Sentry.setTag("app", config.app);
  initialized = true;
}

export function captureError(err: unknown): void {
  Sentry.captureException(err);
}

export function setSentryUser(id: string | null): void {
  if (id === null) Sentry.setUser(null);
  else Sentry.setUser({ id });
}
